import { Outlet } from "react-router-dom";
import { Header } from "@/app/components/Header";
import { Footer } from "@/app/components/Footer";

export function AppLayout() {
  return (
    <div className="app-container-react">
      <Header />

      <div className="body-react">
        <main className="content-react">
          <div className="router-react">
            <Outlet />
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}
